import { useTranslation } from '@eti/providers';
import SubPage from './SubPage';

const RefundsPage = () => {
  const { t } = useTranslation();
  return <SubPage pageTitle={t('PageTitle.rf.refunds.action')} textKey="Refunds.Text" />;
};

export default RefundsPage;
